import React from 'react';
import type { Props } from './types.tsx';

const RealtimeBase = importCond<typeof import('./main-new.tsx'), typeof import('./main-old.tsx')>(
	'jirt-convert-class-to-functional-component',
	'./main-new.tsx',
	'./main-old.tsx',
);

const Realtime = (props: Props) => <RealtimeBase {...props} />;
export default Realtime;
